import * as React from 'react';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';

const HowItWorks = () => {
	return (
		<Container
			maxWidth="md"
			sx={{
				py: { xs: 6, sm: 8 },
			}}
		>
			<Typography
				variant="h2"
				align="center"
				sx={{
					fontSize: { xs: '1.75rem', sm: '2.5rem', md: '3rem' },

					fontWeight: 500,

					mb: { xs: 6, sm: 8 },
				}}
			>
				Näin Lenz Platform toimii – Helppo ja nopea prosessi
			</Typography>

			<Box
				sx={{
					display: 'flex',
					flexDirection: 'column',
					gap: { xs: 4, sm: 6 },
				}}
			>
				{/* Step 1 */}
				<Box sx={{ display: 'flex', gap: 4, alignItems: 'flex-start' }}>
					<Typography
						sx={{
							width: { xs: 36, sm: 48 },
							height: { xs: 36, sm: 48 },
							borderRadius: '50%',
							border: '2px solid',
							borderColor: 'primary.main',
							display: 'flex',
							alignItems: 'center',
							justifyContent: 'center',
							fontSize: { xs: '1.25rem', sm: '1.5rem' },
							fontWeight: 'medium',
							color: 'primary.main',
							flexShrink: 0,
						}}
					>
						1
					</Typography>
					<Box>
						<Typography
							variant="h3"
							sx={{
								fontSize: { xs: '1.5rem', sm: '1.75rem' },
								fontWeight: 500,
								mb: 1,
							}}
						>
							Kuvaile tarpeesi
						</Typography>
						<Typography
							variant="body1"
							sx={{
								fontSize: { xs: '1rem', sm: '1.1rem' },
								color: 'text.secondary',
							}}
						>
							Kerro meille platformin chatissa, millainen haaste
							tai tarve sinulla on. Chattimme toimii kuin
							myyntikonsultti, joka auttaa sinua määrittämään
							tarpeesi ja ehdottaa suoraan vapaita huippuosaajia
							ratkaisemaan sen.
						</Typography>
					</Box>
				</Box>

				{/* Step 2 */}
				<Box sx={{ display: 'flex', gap: 4, alignItems: 'flex-start' }}>
					<Typography
						sx={{
							width: { xs: 36, sm: 48 },
							height: { xs: 36, sm: 48 },
							borderRadius: '50%',
							border: '2px solid',
							borderColor: 'primary.main',
							display: 'flex',
							alignItems: 'center',
							justifyContent: 'center',
							fontSize: { xs: '1.25rem', sm: '1.5rem' },
							fontWeight: 'medium',
							color: 'primary.main',
							flexShrink: 0,
						}}
					>
						2
					</Typography>
					<Box>
						<Typography
							variant="h3"
							sx={{
								fontSize: { xs: '1.5rem', sm: '1.75rem' },
								fontWeight: 500,
								mb: 1,
							}}
						>
							Valitse kandidaatti
						</Typography>
						<Typography
							variant="body1"
							sx={{
								fontSize: { xs: '1rem', sm: '1.1rem' },
								color: 'text.secondary',
							}}
						>

							Jokainen ehdottamamme talentti on pätevä ja valmis
							toteuttamaan tehtävän toiveidesi mukaisesti.

							Tarjoamme laatutakuun, joten voit tehdä valinnan
							huoletta – vääriä päätöksiä ei ole! Halutessasi voit
							myös haastatella ehdokkaita ennen lopullista
							valintaa.
						</Typography>
					</Box>
				</Box>

				{/* Step 3 */}
				<Box sx={{ display: 'flex', gap: 4, alignItems: 'flex-start' }}>
					<Typography
						sx={{
							width: { xs: 36, sm: 48 },
							height: { xs: 36, sm: 48 },
							borderRadius: '50%',
							border: '2px solid',
							borderColor: 'primary.main',
							display: 'flex',
							alignItems: 'center',
							justifyContent: 'center',
							fontSize: { xs: '1.25rem', sm: '1.5rem' },
							fontWeight: 'medium',
							color: 'primary.main',
							flexShrink: 0,
						}}
					>
						3
					</Typography>
					<Box>
						<Typography
							variant="h3"
							sx={{
								fontSize: { xs: '1.5rem', sm: '1.75rem' },
								fontWeight: 500,
								mb: 1,
							}}
						>
							Aloita yhteistyö
						</Typography>
						<Typography
							variant="body1"
							sx={{
								fontSize: { xs: '1rem', sm: '1.1rem' },
								color: 'text.secondary',
							}}
						>
							Varaa 30 minuutin tapaaminen Lenzin perustajan,
							Santtu Laivuoren, kanssa ja viimeistele projektin
							aloitus. Käymme läpi tarpeesi, sovimme käytännön
							asiat ja varmistamme sujuvan aloituksen.
						</Typography>
					</Box>
				</Box>
			</Box>
		</Container>
	);
};

export default HowItWorks;
